import { Coffee } from 'lucide-react';

export default function SupportSection() {
  return (
    <section id="support" className="py-20 sm:py-28 px-4 bg-gray-50/50">
      <div className="max-w-2xl mx-auto text-center">
        <div className="w-14 h-14 rounded-2xl bg-accent-100 flex items-center justify-center mx-auto mb-6">
          <Coffee size={26} className="text-accent-500" />
        </div>
        <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">
          Support the Project
        </h2>
        <p className="mt-4 text-gray-600 text-lg leading-relaxed max-w-lg mx-auto">
          PixelUtility is an independent project focused on creating useful free tools for everyone.
        </p>
        <p className="mt-2 text-gray-500">
          If these tools help you, consider supporting future development ☕
        </p>
        <a
          href="https://www.buymeacoffee.com/pixelutility"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 justify-center mt-8 px-7 py-3 rounded-full bg-accent-400 text-gray-900 font-semibold text-sm hover:bg-accent-300 transition-colors shadow-sm"
        >
          <Coffee size={18} />
          Buy me a coffee
        </a>
      </div>
    </section>
  );
}
